import { createSlice } from "@reduxjs/toolkit";
import { getDeal } from "../reduxApi/dealReduxApi";

const dealSlice = createSlice({
    name: 'deal',
    initialState: {
    status: 'idel',
    isFiltered: false,
    deal: [],
    },
    reducers: {
         setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteDealAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.deal.findIndex((item) => item.deals.ROWID === id);
                if (index !== -1) {
                    state.deal.splice(index, 1);
                }
            });
        },     
       updateDealAction: (state, action) => {
    state.deal = state.deal.map((item) =>
        item.deals.ROWID === action.payload.ROWID
            ? { deals: action.payload }
            : item
    );
},

        addDealAction: (state, action) => {
            const temp = action.payload.formData;
            console.log("action.payload",action.payload);
            
            temp.ROWID = action.payload.ROWID;
            state.deal.unshift({deals:temp});
          }
    },
    extraReducers: (builder) => {
        builder.addCase(getDeal.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getDeal.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.deal = action.payload.data.dealData;
            })
    }
})
export const { deleteDealAction, updateDealAction, addDealAction,setFilteredStatus } = dealSlice.actions
export default dealSlice.reducer